import { dbService } from './db';
import { syncService } from './syncService';
import { useLoaderData } from "react-router";
import React, { useRef, useState, useEffect } from 'react';
import { useOutletContext } from "react-router";
import { userService } from './userService';
import { useOnlineStatus } from './connectivityService';

import {
  Button,
  Input,
  Field,
  Dialog,
  DialogPanel,
  DialogTitle,
  Fieldset,
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
  Textarea,
  Combobox,
  ComboboxInput,
  ComboboxOptions,
  ComboboxOption
} from '@headlessui/react';

import { ArrowDownIcon } from '@heroicons/react/24/outline';

export async function clientLoader({ params }) {
  return {  };
}

export function NewActivity({ reload, isOpen, setIsOpen, customer }) {
  const { activeAccount } = useOutletContext();
  const isOnline = useOnlineStatus();

  const [session, setSession] = useState({});

  const [note, setNote] = useState('');
  const [purpose, setPurpose] = useState('');

  const [itemGroups, setItemGroups] = useState([]);
  const [selectedItemGroup, setSelectedItemGroup] = useState(itemGroups[0]);

  const [activityTypes, setactivityTypes] = useState(['Email', 'Phone']);
  const [selectedActivityType, setSelectedActivityType] = useState(activityTypes[0]);

  const today = new Date().toISOString().split('T')[0]
  const [selectedDate, setSelectedDate] = useState(today)

  const [query, setQuery] = useState('');
  const [selectedCustomer, setSelectedCustomer] = useState(customer);

  const [customers, setCustomers] = useState([]);
  const [filteredCustomers, setFilteredCustomers] = useState([]);

  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setSession(await userService.getSession());
      let db = await dbService.createDB();
      let groupsInternal = [];
      let activityTypesInternal = [];

      let data = await db.getAll("itemGroups");
      if (data.length > 0) {
        data.forEach((it) => {
          groupsInternal.push(it.name);
        });
      }
      setItemGroups(groupsInternal);

      let internalCustomers = await db.getAll("customers");
      setCustomers(internalCustomers);
      
      data = await db.getAll("activityTypes");
      if (data.length > 0) {
        data.forEach((it) => {
          activityTypesInternal.push(it.value);
        });
      }
      setactivityTypes(activityTypesInternal);

    };
    fetchData();
  }, []);

  useEffect(() => {
    if(query.length > 3) {
      setFilteredCustomers(
        query === '' 
          ? customers
          : customers.filter((customer) => {
            return customer.name.toLowerCase().includes(query.toLowerCase())
          }))
    } else {
      setFilteredCustomers([])
    }
      
    }, [query]);

  async function save() {
    let activityAction = {
      data_area: selectedCustomer.data_area, 
      created_at: selectedDate,
      customer_number: selectedCustomer.customer_number,
      customer_name: selectedCustomer.name,
      activity_type: selectedActivityType,
      purpose: purpose,
      item_group: selectedItemGroup,
      memo: note,
      party_id: session.party_id,
      id: crypto.randomUUID(),
      activity_number: `New`,
      is_new: true
    }
    
    let db = await dbService.createDB();
    await db.put("activities", activityAction);
    await db.put("activityAction", activityAction);
    
    if (isOnline) {
      await syncService.syncActivityActions(activeAccount);
    }
    setIsOpen(false);
    reload();
  }

  const handleSave = async () => {
    try {
      setIsSaving(true);
      await save(); 
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <>
      <Dialog open={isOpen} onClose={() => setIsOpen(false)} className="relative z-50">
        <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
          <DialogPanel className="max-w-lg space-y-2 bg-black/90 p-6 rounded-lg border border-2 border-white text-white">
            <DialogTitle className="font-bold">New Activity - {customer?.name}</DialogTitle>
            <div>
              <Fieldset className="space-y-2">

                {!customer &&
                  <Combobox value={selectedCustomer} onChange={setSelectedCustomer} onClose={() => setQuery('')}>
                    <ComboboxInput
                      placeholder="Customer"
                      aria-label="Customers"
                      className="block py-1 px-2 border border-1 rounded-lg w-full appearance-none text-sm"
                      displayValue={(item) => item?.name}
                      onChange={(event) => setQuery(event.target.value)}
                    />
                    <ComboboxOptions
                      anchor="bottom"
                      transition
                      className={" bg-black rounded-lg mx-2 z-[9999] border border-1 absolute w-3/6 right-6 text-sm"}
                    >
                      {filteredCustomers.map((customer) => (
                        <ComboboxOption key={`cust${customer.customer_number}`} value={customer}>
                          {customer.name} - {customer.customer_number}
                        </ComboboxOption>
                      ))}
                    </ComboboxOptions>
                  </Combobox>
                }
                <Field>
                  <Input type="date" className="block py-1 px-2 border border-1 rounded-lg w-full appearance-none text-sm" placeholder="date" name="activityDate" value={selectedDate} onChange={(e) => setSelectedDate(e.target.value)} />
                </Field>
                <Field>
                  <Listbox value={selectedActivityType} onChange={setSelectedActivityType}>
                    <ListboxButton className="flex w-full border border-1 rounded-lg py-1 px-2 text-sm">{selectedActivityType}<ArrowDownIcon className="h-4 ml-auto"></ArrowDownIcon></ListboxButton>
                    <ListboxOptions>
                      <div className="bg-black rounded-lg mx-2 z-[9999] border border-1 absolute w-3/6 right-6 text-sm">
                        {activityTypes.map((activity) => (
                          <ListboxOption key={`activity ${activity}`} value={activity} className="data-focus:bgs-pvs-lightergray bg-pvs-lightergray p-1 mx-2 my-2 text-black rounded-lg">
                            {activity}
                          </ListboxOption>
                        ))}
                      </div>
                    </ListboxOptions>
                  </Listbox>
                </Field>
                <Field>
                  <Input type="text" className="block py-1 px-2 border border-1 rounded-lg w-full text-white appearance-none text-sm" value={purpose} onChange={(e) => setPurpose(e.target.value)} placeholder="Purpose" ></Input>
                </Field>
                <Field>
                  <Listbox value={selectedItemGroup} onChange={setSelectedItemGroup}>
                    <ListboxButton className="flex w-full border border-1 rounded-lg py-1 px-2 text-sm">{selectedItemGroup ? selectedItemGroup : <span className="text-gray-400">Regarding</span>}<ArrowDownIcon className="h-4 ml-auto"></ArrowDownIcon></ListboxButton>
                    <ListboxOptions>
                      <div className="bg-black rounded-lg mx-2 z-[9999] border border-1 absolute w-3/6 right-6 overflow-scroll">
                        {itemGroups.map((itemGroup) => (
                          <ListboxOption key={`itemGroup ${itemGroup}`} value={itemGroup} className="data-focus:bgs-pvs-lightergray bg-pvs-lightergray p-1 mx-2 my-2 text-black rounded-lg text-sm">
                            {itemGroup}
                          </ListboxOption>
                        ))}
                      </div>
                    </ListboxOptions>
                  </Listbox>
                </Field>
                <Field>
                  <Textarea placeholder="Note" className="w-full block py-1 px-2 border border-1 rounded-lg w-full text-white appearance-none text-sm" name="notes" value={note} onChange={(e) => setNote(e.target.value)}></Textarea>
                </Field>
              </Fieldset>
            </div>

            <div className="flex gap-2">
              <Button className="rounded-md w-35 bg-white text-pvs-gray m-2 p-2" onClick={() => setIsOpen(false)}>Cancel</Button>
              <Button className="rounded-md w-35 bg-white text-pvs-gray m-2 p-2" disabled={isSaving} onClick={handleSave}>{isSaving ? "Saving..." : "Save"}</Button>
            </div>
          </DialogPanel>
        </div>
      </Dialog>
    </>
  );
}

